export interface CmsProtectionDetailsExclusions {
  protectionDetailsExclusions: CmsProtectionDetailsExclusion[];
}

export interface CmsProtectionDetailsExclusion {
  item: string;
}
